import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, of, map, exhaustMap } from 'rxjs';
import { MaintenanceApiService } from 'src/app/core/services/maintenance-api/maintenance-api.service';
import { MaintenanceApiActions } from '../../actions/maintenance-api.action';

@Injectable()
export class MaintenanceApiEffects {
  getMaintenanceFlag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MaintenanceApiActions.getMaintenanceFlag),
      exhaustMap(({ tenantId }) =>
        this.maintenanceApiService.getMaintenanceStatus(tenantId).pipe(
          map((resp) =>
            MaintenanceApiActions.getMaintenanceFlagSuccess({
              isMaintenanceActive: resp.isMaintenanceActive,
            })
          ),
          catchError((error) => {
            return of(
              MaintenanceApiActions.getMaintenanceFlagFailure({ error })
            );
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private maintenanceApiService: MaintenanceApiService
  ) {}
}
